var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "el-dialog",
        {
          staticClass: "__pop-set-realname",
          attrs: {
            title: "用户真实姓名设置",
            width: "400px",
            top: "10vh",
            center: true,
            visible: _vm.isShow,
            "append-to-body": true,
          },
          on: {
            close: _vm.closePop,
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "用户真实姓名设置表单",
              staticClass: "form-box",
              attrs: {
                inline: true,
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "120px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { prop: "realName", label: "用户真实姓名：" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "220px" },
                            attrs: {
                              placeholder: "请输入用户真实姓名",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.formData.realName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "realName", $$v)
                              },
                              expression: "formData.realName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-box",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-item cancel-btn",
                  on: { click: _vm.closePop },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-item sure-btn",
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("确定")]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }